import React, { useState, memo } from 'react'
import { SpinningLoader } from 'common-components'
import { COLORS } from 'consts/colors'
import * as Styled from './styled'
import { translate } from 'utils/translations'
import { useDropdownState } from 'hooks/useDropdownState'
import { T } from 'consts/translationKeys'
import { ImagePreviewPopup } from 'components/ImagePreviewPopup'

interface IProps {
  id: number | string
  url: string
  aspectRatio: string
}

const ReferenceImageContent: React.FC<IProps> = ({ id, url, aspectRatio }) => {
  const [isLoading, setIsLoading] = useState(true)
  const { isOpen, closeDropdown, openDropdown } = useDropdownState()

  return (
    <Styled.ReferenceImageWrapper
      $hoverText={translate(T.PREVIEW)}
      onClick={openDropdown}
    >
      {isLoading && (
        <SpinningLoader
          className="loading-spinner"
          size={32}
          loaderColor={COLORS.primaryDark}
        />
      )}
      <Styled.ReferenceImage
        src={url}
        alt={`reference-image-${id}`}
        onLoad={() => setIsLoading(false)}
        $isLoading={isLoading}
      />
      {isOpen && (
        <ImagePreviewPopup
          isOpen={isOpen}
          onClose={closeDropdown}
          url={url}
          aspectRatio={aspectRatio}
        />
      )}
    </Styled.ReferenceImageWrapper>
  )
}
export default memo(ReferenceImageContent)
